import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, makeStyles, TextField, } from "@material-ui/core";
import React from "react";
import { useDispatch } from "react-redux";
import { useFormState } from "../../hooks/useFormState";
import { submitActivityEdit } from "../../redux/actions";
import { editReasonService } from "../../services";
import { isIsoDateString, utcToLocalDate } from "../../utils/dateUtils";
import { SelectListField } from "../common/SelectListField";
const useStyles = makeStyles({
    paper: {
        width: "600px",
    },
    titleStyle: {
        "& h2": {
            fontWeight: "600",
            color: "#949494",
            fontSize: "1.2em",
        },
    },
    contentStyle: {
        color: "#515151",
    },
    changeDetails: {
        padding: 15,
    },
});
export const EditReasonDialog = ({ caseId, isOpen, onDialogClose, handleSubmit, meta, }) => {
    const dialogStyles = useStyles({});
    const dispatch = useDispatch();
    const { formProps, triggerSubmit, triggerReset } = useFormState({
        reason: "",
        note: "",
    }, ["reason", "note"], ({ state }) => {
        handleSubmit();
        dispatch(submitActivityEdit(caseId, state.values.reason, state.values.note, meta));
        onDialogClose();
        triggerReset();
    });
    return (React.createElement(Dialog, { open: isOpen, "aria-labelledby": "form-dialog-title", maxWidth: "md", fullWidth: true, onClose: () => {
            onDialogClose();
        } },
        React.createElement(DialogTitle, null, "Enter a reason for editing the following fields"),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement("form", null,
                React.createElement(Grid, { container: true, spacing: 3 },
                    meta.map(change => (React.createElement("div", { key: change.field },
                        React.createElement("h3", { "data-test": "activity-field-title" }, mapFromCamelCase(change.field)),
                        React.createElement("div", { className: dialogStyles.changeDetails },
                            React.createElement(Grid, { container: true, spacing: 3 },
                                React.createElement(Grid, { item: true },
                                    React.createElement("b", null, "Old value:")),
                                React.createElement(Grid, { item: true, md: 10 }, renderMetaChange(change.field, change.oldValue)),
                                React.createElement(Grid, { item: true },
                                    React.createElement("b", null, "New value:")),
                                React.createElement(Grid, { item: true, md: 10 }, renderMetaChange(change.field, change.newValue))))))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(SelectListField, Object.assign({}, formProps("reason"), { label: "Reason", service: editReasonService }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formProps("note"), { label: "Note", fullWidth: true, multiline: true, rows: 8 })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: onDialogClose, disableRipple: true, color: "primary", id: `save-changes-dialog-cancel-button`, "data-test": `save-changes-dialog-cancel-button` }, "Cancel Save Changes"),
            React.createElement(Button, { onClick: () => triggerSubmit(), disableRipple: true, color: "primary", id: `save-changes-dialog-confirm-button`, "data-test": `save-changes-dialog-confirm-button` }, "Confirm Save Changes"))));
};
export const renderMetaChange = (field, value) => {
    switch (field) {
        case "receiptDate":
        case "closedDate":
            return isIsoDateString(value) ? utcToLocalDate(value) : value;
        default:
            return value;
    }
};
export const mapFromCamelCase = (field) => field
    .replace(/([A-Z])/g, match => ` ${match}`)
    .replace(/^./, match => match.toUpperCase())
    .trim();
